import React from 'react';
import PropTypes from 'prop-types';

import { DialogTitle as MUIDialogTitle } from '@mui/material';

export const DialogTitle = props => <MUIDialogTitle {...props} />;

DialogTitle.propTypes = {
  classes: PropTypes.object,
  disableTypography: PropTypes.bool
};

export default DialogTitle;
